import { Button, Flex, Modal, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

import s from './RemoveFolderPopup.module.scss';

const RemoveFolderPopup: React.FC = () => {
  const {
    popups: { deleteFolderPopup },
  } = useSidebarDocumentsStore();

  return (
    <Modal
      centered
      title={<Text fw="400">Удалить папку</Text>}
      opened={deleteFolderPopup.isOpen}
      onClose={deleteFolderPopup.close}
    >
      <Flex direction="column" align="center" justify="center" gap="lg">
        <Text size="sm" c="gray">
          Вы действительно хотите удалить папку? Все загруженные файлы будут удалены
        </Text>
        <Flex className={s.root__footer} justify="flex-end">
          <Button variant="transparent" onClick={deleteFolderPopup.close} size="sm">
            <Text fw="400" c="dark">
              Отменить
            </Text>
          </Button>
          <Button
            loading={deleteFolderPopup.meta.isLoading}
            variant="filled"
            color="red"
            onClick={deleteFolderPopup.delete}
            size="sm"
          >
            <Text fw="400">Удалить</Text>
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default observer(RemoveFolderPopup);
